import Generator from './generator';

export default class DropoutCurve extends Generator {
  static _lineChartConfig = {
    yAxis: 1,
    type: 'line',
    dashStyle: null,
    showInLegend: true,
    enableMouseTracking: true,
    customTags: ['dropout'],
  };

  getDropoutSeriesData(objectArray) {
    const dropoutSeriesData = this._getSeriesData(
      objectArray,
      'actualDropoutCum',
    );

    return dropoutSeriesData;
  }

  getSeries(objectArray) {
    const lineSeriesData = this.getDropoutSeriesData(objectArray);

    const dropoutSeries = {
      id: 'dropout',
      name: 'Dropout (Actual)',
      data: lineSeriesData,
      color: '#4C3BAD',
      marker: { enabled: lineSeriesData.length === 1 },
      zIndex: 3,
      ...DropoutCurve._lineChartConfig,
    };

    return [dropoutSeries];
  }
}
